import React, { useEffect, useState, useRef } from 'react';
export const AudioLevelMeter = ({ level, isRecording, barCount = 24, barWidth = 3, barGap = 2, height = 24 }) => {
    const [samples, setSamples] = useState([]);
    const animationRef = useRef();
    const lastSampleTime = useRef(0);
    const sampleInterval = 80; // ms between samples
    useEffect(() => {
        if (!isRecording) {
            setSamples([]);
            return;
        }
        const addSample = (timestamp) => {
            if (timestamp - lastSampleTime.current >= sampleInterval) {
                // Apply easing to make lower volumes more visible
                const easedLevel = Math.pow(Math.max(0, Math.min(1, level)), 0.6);
                // Add some minimum height and slight randomness for visual interest
                const sampleValue = Math.max(0.15, easedLevel + (Math.random() * 0.1 - 0.05));
                setSamples(prev => {
                    const newSamples = [...prev, sampleValue];
                    // Keep only the last barCount samples
                    if (newSamples.length > barCount) {
                        return newSamples.slice(-barCount);
                    }
                    return newSamples;
                });
                lastSampleTime.current = timestamp;
            }
            animationRef.current = requestAnimationFrame(addSample);
        };
        animationRef.current = requestAnimationFrame(addSample);
        return () => {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current);
            }
        };
    }, [isRecording, level, barCount]);
    const totalWidth = barCount * (barWidth + barGap) - barGap;
    return (React.createElement("div", { className: "flex items-end justify-end overflow-hidden", style: { width: totalWidth, height } },
        React.createElement("div", { className: "flex items-end gap-[2px]", style: { gap: barGap } },
            samples.map((sample, index) => {
                const barHeight = Math.max(4, sample * height);
                return (React.createElement("div", { key: index, className: "bg-red-500 rounded-full transition-all duration-75", style: {
                        width: barWidth,
                        height: barHeight,
                    } }));
            }),
            Array.from({ length: Math.max(0, barCount - samples.length) }).map((_, index) => (React.createElement("div", { key: `placeholder-${index}`, className: "bg-gray-300 rounded-full", style: {
                    width: barWidth,
                    height: 4,
                } }))))));
};
export default AudioLevelMeter;
